import './index.css';
import { AppRouter } from '@semantical/Router';

import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import Vocabulary from '@semantical/modules/vocabulary/Vocabulary';
import N3 from 'n3';
import { createWorkspace } from '@semantical/modules/workspace';

const vocabulary = new Vocabulary(new N3.Store());

// Create the workspace - this loads from localStorage or initial config
const { workspace, config: workspaceConfig } = createWorkspace();

const root = createRoot(document.getElementById('appContainer')!);
root.render(
    <StrictMode>
        <AppRouter vocabulary={vocabulary} workspace={workspace} workspaceConfig={workspaceConfig} />
    </StrictMode>
);


